export default __webpack_public_path__ + "a466c2afa6e5e6c2d8456fa61ad1ba7a.png";